import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../hooks/useUser";
import { isProTeam, isInternal, initialsFromName } from "../../../../utils";
import { cldUrl } from "../../../../utils/cloudinary";
import IdPill from "../../../../components/IdPill/IdPill";
import { OverflowMenu, MENU_ICONS } from "../../../../components/MenuOptions/OverflowMenu";


export default function ListUserCard({ pro, deleteUser }) {
  const { role } = useUser();
  const navigate = useNavigate();

  const fullName = [pro.firstName, pro.lastName].filter(Boolean).join(" ").trim();
  const name = pro.displayName || fullName;
  const unnamed = !name;
  const secondary = pro.emailAddress;

  const groups = [
    {
      label: "Manage",
      items: [
        {
          key: "edit",
          label: "Edit User",
          icon: MENU_ICONS.edit,
          onClick: () => navigate(`/users/${pro.userid}/admin-edit`),
        },
      ],
    },
    {
      label: "",
      items: [
        {
          key: "delete",
          label: "Delete",
          icon: MENU_ICONS.trash,
          danger: true,
          onClick: () => deleteUser(pro.userid),
        },
      ],
    },
  ];

  return (
    <div
      className="bg-surface border border-border-token rounded-xl w-full box-border cursor-pointer transition-colors duration-150 hover:border-accent flex items-center gap-3"
      style={{ boxShadow: "var(--sh-1)", padding: "13px 15px" }}
      onClick={() => navigate(`/experts/${pro.userid}/${pro.slug || "-"}`)}
      title={name || pro.emailAddress}
    >
      <span className="w-11 h-11 shrink-0 rounded-full bg-surface-2 text-accent-text inline-flex items-center justify-center overflow-hidden font-bold" style={{ fontSize: 14 }}>
        {pro.avatar ? (
          <img
            src={cldUrl(pro.avatar, { w: 88, h: 88, crop: "fill", gravity: "face" })}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover"
          />
        ) : (
          initialsFromName(name) || "—"
        )}
      </span>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <span
            className={`font-bold truncate ${unnamed ? "text-text-2" : "text-text-1"}`}
            style={{ fontSize: 14.5, lineHeight: 1.3 }}
          >
            {name || "Invited · no name yet"}
          </span>
          {pro.usertype && (
            <span
              className="shrink-0 inline-flex items-center h-[19px] px-2 rounded-md bg-surface-2 text-text-2 font-bold uppercase whitespace-nowrap"
              style={{ fontSize: 9.5, letterSpacing: ".08em" }}
            >
              {pro.usertype}
            </span>
          )}
        </div>
        {secondary && (
          <div className="text-text-2 truncate" style={{ marginTop: 3, fontSize: 12 }}>
            {secondary}
          </div>
        )}
      </div>

      <div className="flex items-center gap-1.5 shrink-0" onClick={(e) => e.stopPropagation()}>
        {isInternal(role) && <IdPill value={pro.userid} />}
        {isProTeam(role) && <OverflowMenu groups={groups} ariaLabel="User actions" width={230} />}
      </div>
    </div>
  );
}
